import LazyLoad from "vanilla-lazyload";

export const lazyLoading = new LazyLoad({
  elements_selector: '[data-src], [data-bg]',
  threshold: 400,
});

